import { style } from '@vanilla-extract/css';

export const list = style({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  width: '100%',
  gap: '0.75rem',
  listStyle: 'none',
  margin: 0,
  padding: 0,
});
